/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */
(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var ri = {
        // All pages
        common: {
            init: function() {
                $('.js-mobile-nav-trigger').on('click', function() {
                    event.preventDefault();

                    $('.c-site-nav__mobile-wrap').toggleClass('is-open');
                    $('.c-site-nav__mask').toggleClass('is-active');
                    $(this).toggleClass('is-active');


                    if ($(this).hasClass('is-active') ) {
                        noScroll.on();
                    }

                    else {
                        noScroll.off();
                    }

                });

                // show/hide hdeader on scroll
                $(".js-mobile-nav-trigger").headroom({
                    // vertical offset in px before element is first unpinned
                    offset: 0,
                    // scroll tolerance in px before state changes
                    // tolerance : 0,
                    // or scroll tolerance per direction
                    tolerance: {
                        down: 0,
                        up: 0
                    },
                    // css classes to apply
                    classes: {
                        // when element is initialised
                        initial: "is-initial",
                        // when scrolling up
                        pinned: "is-pinned",
                        // when scrolling down
                        unpinned: "is-unpinned",
                        // when above offset
                        top: "is-top",
                        // when below offset
                        notTop: "is-not-top"
                    }
                });

                $(".js-popup").on('click' , function(e){
                    e.preventDefault();
                    if( isTablet() ) {
                        // prepare popup window
                        var width  = 760,
                            height = 500,
                            left   = ($(window).width()  - width)  / 2,
                            top    = ($(window).height() - height) / 2,
                            opts   = 'status=1' +
                                ',width='  + width  +
                                ',height=' + height +
                                ',top='    + top    +
                                ',left='   + left;

                        // open the url in a smaller window
                        var newW = window.open($(this).attr("href"), 'window', opts);
                    } else {
                         window.open($(this).attr("href"), '_blank' );
                    }
                });

                $('.js-sorting-select').on("change" , function(e){
                    var link = $(this).val();
                    window.location.href = link;
                });

                if ( $('.js-scroll-here').length ) {
                    var offset = $('.js-scroll-here').offset().top;
                    $(window).scrollTop(offset);
                }

                //debounce - smartresize

                /*$(window).smartresize(function(){
                });*/
            }
        },
        // Home page
        home: {
            init: function() {
                $('.js-slick').each( function() {
                    var speed_data = $(this).data('speed');
                    var speed = ( typeof( speed_data ) !== 'undefined' ) ? speed_data : 3000;
                    $(this).slick({
                        dots: false,
                        arrows: false,
                        autoplay: true,
                        fade: true,
                        speed: 500,
                        pauseOnHover: false,
                        autoplaySpeed: speed
                    });
                });

                var $logosSlider = $('.js-logos-slider');

                if ( !isTablet() ) {
                    initLogosSlider($logosSlider);
                }

                $(window).smartresize(function() {
                    if ( !isTablet() ) {
                        if( ! $logosSlider.hasClass('slick-slider') ) {
                            initLogosSlider($logosSlider);
                        }
                    } else {
                        if( $logosSlider.hasClass('slick-slider') ) {
                            $logosSlider.slick('unslick');
                        }
                    }
                });
            }
        },
        // Posts page
        posts_page: {
            init: function() {
                // console.log("posts page");
                // JavaScript to be fired on posts page
            }
        },
        // About us page, note the change from about-us to about_us.
        about_us: {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var namespace = ri;
            funcname = (funcname === undefined) ? 'init' : funcname;
            if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            UTIL.fire('common');

            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
            });
        }
    };

    $(document).ready(UTIL.loadEvents);

    function isTablet() {
        if( $(window).width() >= 770 ) {
            return true;
        } else {
            return false;
        }
    }

    function initLogosSlider( $slider ) {
        $slider.slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                }
            ]
        });
    }

})(jQuery); // Fully reference jQuery after this point.